export default "__VITE_ASSET__D_fRz7tf__"